import React from "react";
import Slider from "react-slick";
import ProductCard from "../PrductCard/ProductCard";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./HomeProducts.css";


const NextArrow = ({ onClick }) => (

    <button
        className="slider-arrow next"
        onClick={onClick}
    >
        <FaChevronRight />
    </button>

);



const PrevArrow = ({ onClick }) => (

    <button
        className="slider-arrow prev"
        onClick={onClick}
    >
        <FaChevronLeft />
    </button>

);



const HomeProducts = ({ title, products }) => {

    const settings = {

        dots: false,

        infinite: false,

        speed: 500,

        slidesToShow: 5,

        slidesToScroll: 1,

        arrows: true,

        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,

        swipeToSlide: true,

        draggable: true,


        responsive: [

            // Laptop large
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 4
                }
            },


            // Laptop small
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },


            // Tablet
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    arrows: false
                }
            },


            // Mobile
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }

        ]

    };

    return (

        <section className="products-section">


            <div className="products-heading">

                <h3>
                    {title}
                </h3>

            </div>



            <Slider {...settings}>


                {
                    products?.map(product => (


                        <div
                            key={product._id}
                            className="product-slide"
                        >

                            <ProductCard

                                image={product.image}

                                name={product.productName}

                                category={product.category}

                                subCategory={product.subCategory}

                                slug={product.slug}

                                product={product}

                            />


                        </div>


                    ))

                }


            </Slider>


        </section>

    );


};


export default HomeProducts;